<div tabindex="0" (click)="OnSelect($event)" (keydown.enter)="OnSelect($event)" (keydown.space)="OnSelect($event)">
    <ng-content></ng-content>
</div>